var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},_vm._l((_vm.banner),function(item,index){return _c('img',{key:index,staticClass:"banner__img",attrs:{"src":item.link,"alt":item.name}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }